// extracted by mini-css-extract-plugin
export var container = "_u4-0";
export var table = "_u4-2";
export var tableWrapper = "_u4-1";